import classNames from "classnames";
import { useProfilePreview } from "PFApp/use_profile_preview";
import { ExpandableCard } from "PFComponents/expandable_card";
import { getProfileName } from "PFCore/helpers/profile";
import { Profile } from "PFTypes";
import { RefObject, useCallback } from "react";
import { TransitionStatus } from "react-transition-group";

import { useMatchCardContext } from "../../match_card_context";
import { MatchCardBody } from "../match_card_body";
import { MatchCardFooter } from "../match_card_footer";
import { MatchCardHeader } from "../match_card_header";
import css from "./animated_match_card.module.scss";

type AnimatedMatchCardProps = {
  ref: RefObject<HTMLDivElement | null>;
  state: TransitionStatus;
  classes?: {
    card?: string;
  };
};

export const AnimatedMatchCard = ({ state, classes, ref }: AnimatedMatchCardProps) => {
  const { showPreview } = useProfilePreview();
  const { profile, animationTrigger, isUnbiasedMode, isProfileSelectedToCompare } = useMatchCardContext();

  const profileName = getProfileName(profile);

  const handleOpenProfile = useCallback(() => {
    if (isUnbiasedMode) {
      return;
    }

    showPreview({ id: profile.id, profile: profile as Profile });
  }, [profile, showPreview, isUnbiasedMode]);

  return (
    <ExpandableCard
      ref={ref}
      header={<MatchCardHeader />}
      onClick={handleOpenProfile}
      ariaLabel={profileName}
      className={classNames(
        css.card,
        css[state],
        {
          [css.selectedCard]: isProfileSelectedToCompare
        },
        classes?.card
      )}
      animationTrigger={animationTrigger}
      footer={<MatchCardFooter />}
    >
      <MatchCardBody />
    </ExpandableCard>
  );
};
